const { default: axiosInstance } = require("utils/axios");

const getReadySellCarList = async (filter) => {
  try {
    const response = await axiosInstance.get(
      "/car-ready-sell/getListCarAvailableForSale",
      {
        params: filter,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching ready sell cars:", error);
    throw error;
  }
};

const getReadySellCarById = async (id) => {
  try {
    const response = await axiosInstance.get(
      `/car-ready-sell/getDetailCarAvailableForSaleById/${id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching ready sell car by ID:", error);
    throw error;
  }
};

const createOrderSellCar = async (data) => {
  const formData = new FormData();

  Object.entries(data).forEach(([key, value]) => {
    if (value instanceof File) {
      formData.append(key, value);
    } else if (
      Array.isArray(value) &&
      value.every((item) => item instanceof File)
    ) {
      value.forEach((file) => formData.append(key, file));
    } else {
      formData.append(key, value);
    }
  });

  try {
    const response = await axiosInstance.post(
      "/car-ready-sell/sellCarAvailableForSale",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating order to sell car:", error);
    throw error;
  }
};

const sendCarToMarketPlace = async (data) => {
  try {
    const response = await axiosInstance.post(
      "/car-ready-sell/sendCarAvailableForSaleToMarketPlace",
      data
    );
    return response.data;
  } catch (error) {
    console.error("Error sending car to marketplace:", error);
    throw error;
  }
};

// documents
const createTransferAndReceiptReady = async (order_id, data) => {
  const formData = new FormData();
  formData.append("data", JSON.stringify(data));
  try {
    const response = await axiosInstance.post(
      `/car-ready-sell/createCarTransformContact/${order_id}`,
      formData,
      { headers: { "Content-Type": "application/json" } }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating transfer and receipt car document:", error);
    throw error;
  }
};

const getTransferAndReceiptReadyByID = async (document_id) => {
  try {
    const response = await axiosInstance.get(
      `/car-ready-sell/get-car-transfer/${document_id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching transfer and receipt car by ID:", error);
    throw error;
  }
};

const updateTransferAndReceiptReadySell = async (document_id, data) => {
  try {
    const formData = new FormData();
    formData.append("data", JSON.stringify(data));
    const response = await axiosInstance.put(
      `/car-ready-sell/update-car-transform/${document_id}`,
      formData,
      { headers: { "Content-Type": "application/json" } }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating transfer and receipt car document:", error);
    throw error;
  }
};

const printPdfCarTransferSell = async (document_id) => {
  try {
    const response = await axiosInstance.get(
      `/car-ready-sell/get-car-transfer-pdf/${document_id}`,
      { responseType: "blob" }
    );
    return response;
  } catch (error) {
    console.error("Error printing PDF car transfer:", error);
    throw error;
  }
};

const createPowerOfAttorneyReady = async (order_id, data) => {
  try {
    const response = await axiosInstance.post(
      `/car-ready-sell/createCarPowerOfAttorney/${order_id}`,
      { ...data },
      { headers: { "Content-Type": "application/json" } }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating power of attorney document:", error);
    throw error;
  }
};

const updatePowerOfAttorneyReady = async (document_id, data) => {
  try {
    const formData = new FormData();
    formData.append("doc_data", JSON.stringify(data));
    const response = await axiosInstance.put(
      `/car-ready-sell/update-power-of-attorney/${document_id}`,
      formData,
      { headers: { "Content-Type": "application/json" } }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating power of attorney document:", error);
    throw error;
  }
};

const getPowerOfAttorneyReadyByID = async (document_id) => {
  try {
    const response = await axiosInstance.get(
      `/car-ready-sell/get-car-power-of-attorney/${document_id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching power of attorney car by ID:", error);
    throw error;
  }
};

const printPdfPowerOfAttorneySell = async (document_id) => {
  try {
    const response = await axiosInstance.get(
      `/car-ready-sell/get-car-power-of-attorney-pdf/${document_id}`,
      { responseType: "blob" }
    );
    return response;
  } catch (error) {
    console.error("Error printing PDF power of attorney:", error);
    throw error;
  }
};

const createSellCarContract = async (order_id, data) => {
  try {
    const formData = new FormData();
    formData.append("data", JSON.stringify(data));
    const response = await axiosInstance.post(
      `/car-ready-sell/createSellCarContract/${order_id}`,
      formData,
      { headers: { "Content-Type": "application/json" } }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating sell car contract document:", error);
    throw error;
  }
};

const getSellCarContractByID = async (document_id) => {
  try {
    const response = await axiosInstance.get(
      `/car-ready-sell/get-car-sale-contact/${document_id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching sell car contract by ID:", error);
    throw error;
  }
};

const updateSellCarContract = async (document_id, data) => {
  try {
    const response = await axiosInstance.put(
      `/car-ready-sell/update-car-sell-contact/${document_id}`,
      { ...data },
      { headers: { "Content-Type": "application/json" } }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating sell car contract document:", error);
    throw error;
  }
};

const printPdfSellCarContract = async (document_id) => {
  try {
    const response = await axiosInstance.get(
      `/car-ready-sell/get-car-sell-contact-pdf/${document_id}`,
      { responseType: "blob" }
    );
    return response;
  } catch (error) {
    console.error("Error printing PDF sell car contract:", error);
    throw error;
  }
};
const updateSellPriceCar = async (car_id, data) => {
  try {
    const response = await axiosInstance.put(
      `/car-ready-sell/updateSellPrice/${car_id}`,
      data
    );
    return response.data;
  } catch (error) {
    console.error("Error updating sell price car:", error);
    throw error;
  }
};

const cancelSellCarOrder = async (car_id) => {
  try {
    const response = await axiosInstance.delete(
      `/car-ready-sell/cancel-reserved-car/${car_id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error canceling sell car order:", error);
    throw error;
  }
};

const ReadySellCarService = {
  getReadySellCarList,
  getReadySellCarById,
  createOrderSellCar,
  sendCarToMarketPlace,
  // documents
  createTransferAndReceiptReady,
  getTransferAndReceiptReadyByID,
  updateTransferAndReceiptReadySell,
  createPowerOfAttorneyReady,
  updatePowerOfAttorneyReady,
  getPowerOfAttorneyReadyByID,
  createSellCarContract,
  getSellCarContractByID,
  updateSellCarContract,
  printPdfSellCarContract,
  printPdfPowerOfAttorneySell,
  printPdfCarTransferSell,

  updateSellPriceCar,
  cancelSellCarOrder,
};

export default ReadySellCarService;
